import { type GetPaymentsOverviewsResponse, GetPaymentsOverviewsResponseSchema } from '@weft/api-definition';
import type { WeftApi } from '@weft/client';
import { isEmptyString, withDefault } from '@weft/utils';
import type { QueryClient, UseQueryOptions } from 'react-query';
import { useQuery, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { PAYMENTS_OVERVIEWS_PAGE_SIZE } from './use-payments-overviews-consts';

type UsePaymentsOverviewsPayload = Parameters<WeftApi['getPaymentOverviews']>[0];

export function usePaymentsOverviews(payload: UsePaymentsOverviewsPayload, options?: UseQueryOptions<GetPaymentsOverviewsResponse>) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['paymentsOverviews', payload],
    queryFn: async ({ signal }) => {
      const api = getPrivateApi();
      await cancelGetPaymentsOverviewsQueries(queryClient);

      const getPaymentsOverviewsResponse = await api.getPaymentOverviews(
        {
          pageSize: withDefault(payload.pageSize, PAYMENTS_OVERVIEWS_PAGE_SIZE),
          page: withDefault(payload.page, 0),
          search: isEmptyString(payload.search) ? undefined : payload.search,
          startTime: payload.startTime,
          endTime: payload.endTime,
        },
        {
          signal,
        });

      return GetPaymentsOverviewsResponseSchema.parse(getPaymentsOverviewsResponse);
    },
    ...options,
  },
  );
}

async function cancelGetPaymentsOverviewsQueries(queryClient: QueryClient) {
  await queryClient.cancelQueries({
    predicate: (query) => query.queryKey[0] === 'paymentsOverviews',
  });
}